import * as React from "react";
import TextField from "@mui/material/TextField";

// Native sizing avoids the ResizeObserver feedback loop previously seen here.
export default function NcrDetailTextField({ value, InputProps, ...props }) {
  const input = React.useRef(null);
  const resize = React.useCallback(() => {
    const field = input.current;
    if (!field) return;
    const style = window.getComputedStyle(field);
    const lineHeight =
      parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
    const padding =
      (parseFloat(style.paddingTop) || 0) +
      (parseFloat(style.paddingBottom) || 0);
    const border =
      (parseFloat(style.borderTopWidth) || 0) +
      (parseFloat(style.borderBottomWidth) || 0);
    field.style.overflowY = "hidden";
    field.style.height = "0px";
    const height = Math.max(lineHeight + padding, field.scrollHeight);
    const maximum = lineHeight * 5 + padding;
    field.style.height = `${Math.min(height, maximum) + border}px`;
    field.style.overflowY = height > maximum ? "auto" : "hidden";
  }, []);
  React.useLayoutEffect(resize, [resize, value]);
  React.useEffect(() => {
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [resize]);
  return (
    <TextField
      {...props}
      value={value}
      size="small"
      multiline
      rows={1}
      inputRef={input}
      InputProps={{ ...InputProps, inputComponent: "textarea" }}
      inputProps={{ style: { resize: "none", boxSizing: "border-box" } }}
    />
  );
}
